__turbopack_context__.v({
  "approachSection": "_2Kcjfa_approachSection",
  "brandCaption": "_2Kcjfa_brandCaption",
  "brandFigure": "_2Kcjfa_brandFigure",
  "brandImage": "_2Kcjfa_brandImage",
  "brandImageGrid": "_2Kcjfa_brandImageGrid",
  "fontWaterfall": "_2Kcjfa_fontWaterfall",
  "hero": "_2Kcjfa_hero",
  "heroAccent": "_2Kcjfa_heroAccent",
  "imageGrid": "_2Kcjfa_imageGrid",
  "logoCaption": "_2Kcjfa_logoCaption",
  "logoCard": "_2Kcjfa_logoCard",
  "logoCardDark": "_2Kcjfa_logoCardDark",
  "logoCardGradient": "_2Kcjfa_logoCardGradient",
  "logoCardLight": "_2Kcjfa_logoCardLight",
  "logoCardMark": "_2Kcjfa_logoCardMark",
  "logoCardWordmark": "_2Kcjfa_logoCardWordmark",
  "logoGrid": "_2Kcjfa_logoGrid",
  "logoGridSection": "_2Kcjfa_logoGridSection",
  "logoGridWordmarks": "_2Kcjfa_logoGridWordmarks",
  "logoImageMark": "_2Kcjfa_logoImageMark",
  "logoImageRound": "_2Kcjfa_logoImageRound",
  "logoImageWordmark": "_2Kcjfa_logoImageWordmark",
  "metaBlock": "_2Kcjfa_metaBlock",
  "metaGrid": "_2Kcjfa_metaGrid",
  "metaLabel": "_2Kcjfa_metaLabel",
  "metaLeft": "_2Kcjfa_metaLeft",
  "metaOverview": "_2Kcjfa_metaOverview",
  "metaRight": "_2Kcjfa_metaRight",
  "metaSection": "_2Kcjfa_metaSection",
  "metaText": "_2Kcjfa_metaText",
  "metaTools": "_2Kcjfa_metaTools",
  "metricDetail": "_2Kcjfa_metricDetail",
  "metricItem": "_2Kcjfa_metricItem",
  "metricLabel": "_2Kcjfa_metricLabel",
  "metricValue": "_2Kcjfa_metricValue",
  "metricsContent": "_2Kcjfa_metricsContent",
  "metricsGrid": "_2Kcjfa_metricsGrid",
  "metricsSection": "_2Kcjfa_metricsSection",
  "outcomesSection": "_2Kcjfa_outcomesSection",
  "page": "_2Kcjfa_page",
  "paletteCard": "_2Kcjfa_paletteCard",
  "paletteCardExcellent": "_2Kcjfa_paletteCardExcellent",
  "paletteCardFair": "_2Kcjfa_paletteCardFair",
  "paletteCardFooter": "_2Kcjfa_paletteCardFooter",
  "paletteCardGood": "_2Kcjfa_paletteCardGood",
  "paletteCardHeader": "_2Kcjfa_paletteCardHeader",
  "paletteCardMutedTeal": "_2Kcjfa_paletteCardMutedTeal",
  "paletteCardNearBlack": "_2Kcjfa_paletteCardNearBlack",
  "paletteCardPoor": "_2Kcjfa_paletteCardPoor",
  "paletteCardPureWhite": "_2Kcjfa_paletteCardPureWhite",
  "paletteCardSurface": "_2Kcjfa_paletteCardSurface",
  "paletteCardTeal": "_2Kcjfa_paletteCardTeal",
  "paletteCardWarmInk": "_2Kcjfa_paletteCardWarmInk",
  "paletteCardWarmWhite": "_2Kcjfa_paletteCardWarmWhite",
  "paletteCardWhite": "_2Kcjfa_paletteCardWhite",
  "paletteGrid": "_2Kcjfa_paletteGrid",
  "paletteGridThree": "_2Kcjfa_paletteGridThree",
  "paletteHex": "_2Kcjfa_paletteHex",
  "paletteImage": "_2Kcjfa_paletteImage",
  "paletteName": "_2Kcjfa_paletteName",
  "paletteRole": "_2Kcjfa_paletteRole",
  "paletteSection": "_2Kcjfa_paletteSection",
  "paletteSectionTitle": "_2Kcjfa_paletteSectionTitle",
  "paletteUsage": "_2Kcjfa_paletteUsage",
  "problemMindmap": "_2Kcjfa_problemMindmap",
  "processSection": "_2Kcjfa_processSection",
  "roundedImage": "_2Kcjfa_roundedImage",
  "storySection": "_2Kcjfa_storySection",
  "storySectionAlt": "_2Kcjfa_storySectionAlt",
  "waterfallColumn": "_2Kcjfa_waterfallColumn",
  "waterfallLabel": "_2Kcjfa_waterfallLabel",
  "waterfallMonoLine": "_2Kcjfa_waterfallMonoLine",
  "waterfallSansLine": "_2Kcjfa_waterfallSansLine",
  "waterfallSize2xl": "_2Kcjfa_waterfallSize2xl",
  "waterfallSize4xl": "_2Kcjfa_waterfallSize4xl",
  "waterfallSizeLg": "_2Kcjfa_waterfallSizeLg",
  "waterfallSizeMd": "_2Kcjfa_waterfallSizeMd",
  "waterfallSizeSpecimen": "_2Kcjfa_waterfallSizeSpecimen",
  "waterfallSizeXl": "_2Kcjfa_waterfallSizeXl",
  "waterfallWrap": "_2Kcjfa_waterfallWrap",
});
